import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { Field } from 'redux-form';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import store from './../../../../../store';
import InputView from './InputView';

import DeleteIcon from '@mui/icons-material/Delete';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { __SetFilter } from '../../../../../actions/AsyncTable';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { change } from 'redux-form';

export default ({ label, fields, meta: { error }, mindex, ...custom }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const formState = useSelector(state => state.form || {}, shallowEqual);
    const filterFormName = useMemo(() => {
        return Object.keys(formState).find(name => name.startsWith('filter-'));
    }, [formState]);
    const didAutoInitRef = useRef(false);

    const handleAddButton = useCallback(() => {
        if (!filterFormName) return;
        fields.push();
    }, [fields, filterFormName]);

    useEffect(() => {
        if (didAutoInitRef.current) return;
        if (!filterFormName) return;
        if (fields.length) {
            didAutoInitRef.current = true;
            return;
        }
        dispatch(change(filterFormName, fields.name, ['']));
        didAutoInitRef.current = true;
    }, [dispatch, fields.length, fields.name, filterFormName]);

    return (
        <Card>
            <CardContent>
                <div style={{ display: 'flex', marginBottom: 16 }}>
                    <Stack spacing={3} direction={'row'} alignItems={'center'}>
                        <Typography gutterBottom variant="h6" component="h2" style={{ marginBottom: 'unset' }}>
                            {label}
                        </Typography>
                        <IconButton onClick={() => __SetFilter()(store.dispatch, store.getState)(custom.data)}>
                            <DeleteIcon />
                        </IconButton>
                    </Stack>
                    <div style={{ flex: 1 }} />
                    <Tooltip placement="top" title={t('table.add_rule')}>
                        <IconButton onClick={handleAddButton}>
                            <AddIcon />
                        </IconButton>
                    </Tooltip>
                </div>
                <Grid container spacing={3} justifyContent="flex-end">
                    {fields.map((member, index) => (
                        <Grid item xs={12} key={index}>
                            <Field
                                name={member}
                                type="text"
                                component={InputView}
                                action={
                                    <InputAdornment position="end">
                                        <Tooltip placement="top" title={t('table.remove_rule')}>
                                            <IconButton onClick={() => fields.remove(index)}>
                                                <CloseIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                }
                                label={label}
                                isNumber={true}
                                item={custom.data}
                            />
                        </Grid>
                    ))}
                    {error && (
                        <Grid item xs={12}>
                            <Typography variant="body2" component="p" color="error">
                                {error}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </CardContent>
        </Card>
    );
};
